/* eslint-disable react/no-string-refs, react/no-array-index-key */
import React from 'react';
import filterOptionValues from '../../../../constants/filterOptionValues';
import { withNamespaces } from 'react-i18next';

class YearSelector extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.props.onChange(e.target.value);
  }

  getYears() {
    const years = [];

    // Kanban-32166 // kanban-47605 güncellendi
    const fullYear = new Date().getFullYear() + 1;

    for (let y = 2018; y <= fullYear; y++) {
      years.push(y);
    }

    return years;
  }

  render() {
    const { filterOptionValue, t } = this.props;
    const years = filterOptionValues[filterOptionValue].years;

    return (
      <div className="form-group" style={{ marginBottom: 0 }}>
        {this.props.title ? (
          <label>
            {this.props.title}
          </label>
        ) : null}
        {
                    years.length > 0
                      ? (
                        <select
                          ref="select"
                          id="years"
                          className="form-control input-sm border-input select-input"
                          value={this.props.value || 0}
                          onChange={this.onChange}
                        >
                          <option key="0" value="0">
                                    {t('selectYear')}
                          </option>
                          {
                                    years.map((year, index) => (
                                      <option key={index}>
                                        {year}
                                      </option>
                                    ))
                                }
                        </select>
                      )
                      : (
                        <select
                          ref="select"
                          className="form-control input-sm border-input select-input"
                          value={this.props.value || 0}
                          onChange={this.onChange}
                          id="years1"
                        >
                          <option key="0" value="0">
                                    {t('selectYear')}
                          </option>
                          {
                                    this.getYears().map((year, key) => (
                                      <option key={key} value={year}>
                                        {year}
                                      </option>
                                    ))
                                }
                        </select>
                      )
                }
      </div>
    );
  }
}

export default withNamespaces()(YearSelector);



// WEBPACK FOOTER //
// ./src/components/common/selector/year/index.js